import React from 'react';
import { CYAN } from '../const';

const SVG = ({ style = {}, color = CYAN, width = '100%', viewBox = '0 0 100 100' }) => (
  <svg style={style} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g stroke={color} fill={color} strokeLinecap="round">
      <circle cx="50" cy="50" r="46" fill="none" strokeWidth="8" />
      <circle cx="50" cy="36" r="10" />

      <line x1="44" y1="57" x2="22" y2="50" strokeWidth="9" />
      <line x1="22" y1="50" x2="28" y2="27" strokeWidth="9" />

      <line x1="56" y1="57" x2="78" y2="50" strokeWidth="9" />
      <line x1="78" y1="50" x2="72" y2="27" strokeWidth="9" />

      <rect x="39" y="51" width="22" height="35" />
    </g>
  </svg>
);

export default SVG;
